<script setup lang="ts">
defineOptions({ name: "SectionCard" });

interface Props {
  title?: string;
  description?: string;
}

withDefaults(defineProps<Props>(), { title: "", description: "" });
</script>

<template>
  <Card class="flex flex-col gap-small">
    <div v-if="title || description || $slots.actions" class="flex items-start justify-between gap-small">
      <div class="flex flex-col gap-2xsmall">
        <h2 v-if="title" class="text-body-primary">{{ title }}</h2>
        <span v-if="description" class="text-body-small-tertiary content-neutral-medium">{{ description }}</span>
      </div>
      <slot name="actions" />
    </div>
    <slot />
  </Card>
</template>
